export default "__VITE_ASSET__847ee0d0__"